// extracted by mini-css-extract-plugin
export default {"question":"L_cR","titleLabel":"L_cS","prosCons":"L_cT","pros":"L_cV","cons":"L_cW"};